var SliderPrayer = (function($) {

  var _s = {
    container: '.chm-block-slider-prayer',
    slides: '.chm-block-slider-prayer__slides',
    slide: '.chm-block-slider-prayer__slide',
    arrows: '.chm-block-slider-prayer__arrows',
    dots: '.chm-block-slider-prayer__dots'
  };

  var _init = function() {
    $(_s.container).each(function() {
      let arrows = $(this).find(_s.arrows);
      let dots = $(this).find(_s.dots);
    
      $(this).find(_s.slides).slick({
        autoplay:false,
        infinite: true,
        speed:500,
        adaptiveHeight: true,
        centerMode: false,
        arrows: true,
        appendArrows: arrows,
        prevArrow:'<div class="slick-prev"><i class="fa-light fa-chevron-left"></i></div>',
        nextArrow:'<div class="slick-next"><i class="fa-light fa-chevron-right"></i></div>',
        dots: true,
        appendDots: dots,
        mobileFirst:true,
        responsive: [
          {
            breakpoint: 576,
            settings: {
              adaptiveHeight:false,
              centerMode: true,
              centerPadding: 'clamp(120px, 20vw, 300px)',
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
      });
    });

    _bindEvents();
  };

  var _bindEvents = function() {

  };

  return {
    init: _init
  };

})(jQuery);